import { defineStore } from "pinia";
const useProductFulfillmentStore = defineStore("productFulfillmentStore", {
  state: () => ({
    shipping: {
      selectedStore: {
        storeFulfillmentType: null,
        estimatedArrivalTimestamp: null
      },
      shippingAddress: {
        postalCode: null
      },
      shippingAvailability: {
        estimatedArrivalTimestamp: null
      }
    }
  }),
  getters: {
    computedSelectedShippingMethod() {
      return "not implemented yet";
    }
  },
  actions: {}
});
export {
  useProductFulfillmentStore as default
};
//# sourceMappingURL=productFulfillmentStore.mjs.map
